<template>
  <div class="review-list">
    <div class="review-list-boxes review-list-feed">
      <div class="review-list-box"
        :key="index"
        v-for="({ pic, name, date, stars, text }, index) in shortList">

        <div class="review-list-box-header">
          <img :src="require(`@/assets/images/${pic}`)" />

          <div class="review-list-box-title">
            <h4>{{ name }}</h4>
            <p class="review-list-box-date">{{ date }}</p></div>

          <div class="review-list-box-rating">
            <template v-for="(star, index) in stars">
              <icon :name="star" :key="index" />
            </template></div>
        </div>
        <p class="review-list-box-text">{{ text }}</p>
      </div>
      <div @click="more = !more" v-if="!more" class="view-more">
        View more
      </div>
    </div>

    <carousel-3d
      perspective="0"
      controlsWidth="100"
      controlsHeight="100"
      width="450"
      height="370"
      border="0"
      display="3"
      space="400"
      :controlsVisible="true"
      controlsPrevHtml='<svg width="29" height="78" viewBox="0 0 29 78" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26 2L3 38.3841L26 76" stroke="white" stroke-width="5"/></svg>'
      controlsNextHtml='<svg width="29" height="78" viewBox="0 0 29 78" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 76L26 39.6159L3 2" stroke="white" stroke-width="5"/></svg>'>
      <slide
        v-for="({ pic, name, date, stars, text }, index) in reviews"
        :index="index"
        :key="index">
        <div class="review-list-box review-list-carousel">
          <div class="review-list-box-header">
            <img :src="require(`@/assets/images/${pic}`)" />

            <div class="review-list-box-title">
              <h4>{{ name }}</h4>
              <p class="review-list-box-date">{{ date }}</p></div>

            <div class="review-list-box-rating">
              <template v-for="(star, index) in stars">
                <icon :name="star" :key="index" />
              </template></div>
          </div>
          <p class="review-list-box-text">{{ text }}</p>
        </div>
      </slide>
    </carousel-3d>
  </div>
</template>

<script>
import Icon from '@/components/Icon'
import reviewsData from '@/data/reviews.json'
export default {
  components: {
    Icon
  },
  data: function () {
    return {
      reviews: reviewsData,
      more: false
    }
  },
  computed: {
    shortList () {
      return this.more ? this.reviews : this.reviews.slice(0, 3)
    }
  }
}
</script>

<style lang="scss">
  @import '~@/styles/media';

  .review-list {
    padding: 30px 0 60px 0;
    margin-bottom: 20px;

    &-review-boxes {
      margin-top: 30px;
      margin-bottom: 50px;
    }

    &-feed {
      display: block;

      .view-more {
        background-color: var(--primary-green);
        width: 500px;
        max-width: 100%;
        border-radius: 5px;
        cursor: pointer;
        font-family: 'ProximaNova-Bold';
        text-transform: none;
        font-size: 17px;
      }
    }

    &-box {
      text-align: left;
      border-radius: 17px;
      background-color: var(--primary-white);
      padding: 25px;
      cursor: pointer;
      display: inline-block;
      position: relative;
      z-index: 2;
      vertical-align: middle;
      margin-bottom: 25px;
      box-shadow: 0 17px 43px rgba(0, 0, 0, .15);

      &-header {
        display: grid;
        grid-template-columns: auto auto 1fr;
        grid-column-gap: 10px;
        align-items: end;
        margin-bottom: 20px;

        img {
          width: 55px;
        }
      }

      &-title {
        h4 {
          font-weight: normal;
          font-size: 18px;
          margin: 0;
        }

        p {
          font-size: 14px;
          margin: 0;
          line-height: 1.8;
        }
      }

      &-date {
        color: var(--text-grey);
        font-size: 14px;
      }

      &-rating {
        text-align: right;

        div {
          margin-right: 5px;

          @media #{$lxs} {
            svg {
              height: 17px;
              width: 17px;
            }
          }

          @media #{$s} {
            margin-right: 3px;

            svg {
              height: 12px;
              width: 12px;
            }
          }
        }
      }

      &-text {
        font-size: 14px;
        margin: 0;
        line-height: 1.8;
      }
    }

    &-carousel {
      display: none;
      width: 450px;
      height: 370px;
      padding: 24px 35px;
    }

    .carousel-3d-container {
      display: none;
      margin-bottom: 0!important;
      height: 410px!important;
    }

    .carousel-3d-controls {
      margin-top: -60px!important;
      max-width: 1040px;
      margin: auto;
      right: 0;

      &:hover a {
        opacity: 1!important;
      }
    }

    .carousel-3d-slide {
      background: none;
      box-shadow: 7px 7px 15px rgba(0, 0, 0, .10);
      overflow: hidden;
      border-radius: 17px;
    }

    @media #{$desktop} {
      padding: 30px 0;

      .carousel-3d-container {
        display: block;
      }

      &-feed {
        display: none;
      }

      &-carousel {
        display: block;
      }

      &-box {
        &-header {
          grid-column-gap: 20px;
          img {
            width: 100%;
          }
        }

        &-title {
          h4 {
            font-size: 25px;
          }

          p {
            font-size: 18px;
          }
        }

        &-date {
          font-size: 20px;
        }

        &-text {
          font-size: 18px;
        }
      }
    }
  }
</style>
